var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 391,
    viewBox: "0 0 582 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M550.404 82.3402C550.414 79.836 547.053 78.9805 545.875 81.1901C534.48 102.553 502.848 157.634 467.292 182.736C409.397 223.607 360.095 299.806 380.522 349.379C380.522 349.379 549.268 355.201 550.404 82.3402Z",
    fill: "#E51E25",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M538.62 113.808C538.402 114.505 538.155 115.102 537.92 115.737L537.184 117.607L535.672 121.326C534.65 123.8 533.602 126.262 532.547 128.722C530.423 133.634 528.238 138.52 526.009 143.386C521.535 153.111 516.808 162.718 511.933 172.249C507.066 181.785 501.951 191.194 496.645 200.494L494.661 203.985L492.632 207.45C491.269 209.754 489.948 212.083 488.546 214.365L484.389 221.237L480.128 228.046C468.67 246.141 456.258 263.654 442.651 280.214C441.816 281.26 440.946 282.28 440.069 283.292L437.453 286.342L434.836 289.391C433.951 290.397 433.04 291.379 432.143 292.374C430.332 294.348 428.567 296.363 426.718 298.302L421.138 304.087C413.555 311.656 405.638 318.897 397.249 325.56C397.132 325.653 396.961 325.633 396.868 325.516C396.777 325.401 396.794 325.234 396.906 325.139L396.909 325.137C405.11 318.283 412.906 310.971 420.336 303.302L425.835 297.48C427.657 295.53 429.396 293.502 431.18 291.516C432.063 290.516 432.961 289.528 433.832 288.517L436.408 285.451L438.984 282.385C439.847 281.367 440.703 280.343 441.525 279.29L446.53 273.038C448.186 270.944 449.784 268.805 451.414 266.69C452.221 265.627 453.043 264.575 453.839 263.503L456.203 260.27L458.567 257.037C459.359 255.962 460.143 254.882 460.902 253.782C467.11 245.09 472.971 236.155 478.743 227.167C490.22 209.143 500.769 190.535 510.723 171.62C515.684 162.154 520.46 152.589 525.055 142.938C527.359 138.115 529.618 133.271 531.817 128.399C532.91 125.96 533.995 123.518 535.055 121.065L536.623 117.377L537.386 115.526C537.627 114.911 537.893 114.273 538.089 113.697L538.108 113.641C538.156 113.5 538.309 113.425 538.45 113.473C538.588 113.521 538.663 113.67 538.62 113.808Z",
    fill: "#DCE5FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6573 69.3795C63.9373 67.3536 66.3172 66.4042 67.9229 67.6708C92.4996 87.0602 230.914 205.736 142.881 355.626C142.881 355.626 31.6455 300.955 63.6573 69.3795Z",
    fill: "#E51E25",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5193 97.842C75.7417 97.7214 76.0196 97.8034 76.1414 98.0249C80.9565 106.798 85.5843 115.66 90.1375 124.565C94.6861 133.471 99.1316 142.43 103.472 151.439C112.154 169.459 120.435 187.675 128.15 206.138C135.85 224.603 143.02 243.307 149.154 262.375C152.251 271.897 155.005 281.537 157.388 291.276C159.756 301.015 161.745 310.868 162.943 320.856C163.014 321.451 162.59 321.992 161.995 322.063C161.4 322.134 160.86 321.71 160.788 321.115L160.788 321.109L160.787 321.105C159.655 311.229 157.734 301.44 155.431 291.747C153.113 282.056 150.421 272.443 147.384 262.939C141.371 243.907 134.314 225.204 126.723 206.729C119.117 188.258 110.94 170.019 102.361 151.972C98.0716 142.948 93.6764 133.974 89.1781 125.052C84.6764 116.133 80.0945 107.247 75.3362 98.4693L75.3341 98.4655C75.2133 98.242 75.2961 97.9628 75.5193 97.842Z",
    fill: "#DCE5FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.413 41.7205C213.674 39.8971 216.442 40.1426 217.376 42.1535C231.673 72.9348 307.56 255.462 149.071 357.439C149.071 357.439 68.1788 250.136 212.413 41.7205Z",
    fill: "#1877F2",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.445 75.5453C210.811 86.3883 210.952 97.2265 211 108.069C211.043 118.911 210.962 129.753 210.753 140.594C210.544 151.434 210.209 162.273 209.744 173.106C209.275 183.94 208.638 194.767 207.866 205.585C206.281 227.217 204.066 248.82 200.673 270.265C199.01 280.992 196.958 291.665 194.5 302.25C192.026 312.829 189.13 323.332 185.404 333.577C185.199 334.14 184.576 334.43 184.013 334.225C183.45 334.021 183.16 333.398 183.364 332.835L183.366 332.83L183.368 332.825C187.102 322.711 190.03 312.295 192.54 301.787C195.035 291.273 197.131 280.654 198.839 269.97C202.324 248.61 204.639 227.059 206.326 205.469C207.149 194.671 207.837 183.861 208.358 173.042C208.874 162.223 209.261 151.397 209.521 140.567C209.782 129.738 209.916 118.904 209.925 108.071C209.929 97.2385 209.839 86.4003 209.526 75.5781V75.5737C209.519 75.32 209.719 75.1085 209.973 75.1011C210.226 75.0938 210.437 75.2913 210.445 75.5453Z",
    fill: "#DCE5FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.445 339.022C452.445 339.022 456.853 316.323 482.388 302.09C506.08 288.885 563.778 259.534 579.857 236.698C580.57 235.687 582.198 236.749 581.98 238.087C579.643 252.435 571.156 287.308 541.923 313.347C504.224 346.926 452.445 339.022 452.445 339.022Z",
    fill: "#1877F2",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M567.653 259.05C566.853 261.802 565.689 264.437 564.38 266.988C563.095 269.557 561.593 272.01 560.014 274.414C556.802 279.189 553.013 283.57 548.872 287.572C540.664 295.691 530.667 301.834 520.47 306.973C517.923 308.278 515.358 309.548 512.792 310.816C510.215 312.059 507.633 313.294 505.031 314.482C502.438 315.692 499.826 316.855 497.218 318.029L489.351 321.433C484.105 323.692 478.861 325.941 473.724 328.379C471.145 329.58 468.636 330.905 466.188 332.333C465.002 333.102 463.773 333.818 462.658 334.684C461.479 335.476 460.443 336.435 459.366 337.356L459.352 337.368C459.238 337.465 459.067 337.452 458.969 337.338C458.878 337.231 458.885 337.072 458.981 336.972C460.994 334.903 463.276 333.114 465.678 331.523C468.103 329.975 470.595 328.531 473.144 327.218C478.237 324.573 483.464 322.247 488.649 319.854L496.426 316.273C499.014 315.075 501.608 313.89 504.178 312.659C509.33 310.219 514.443 307.704 519.517 305.112C522.031 303.781 524.607 302.524 527.04 301.096L530.739 299.012C531.944 298.272 533.117 297.481 534.309 296.719L536.09 295.565C536.696 295.198 537.236 294.738 537.816 294.333L541.244 291.832C542.358 290.962 543.43 290.039 544.527 289.145C545.067 288.689 545.628 288.255 546.153 287.781L547.709 286.339C551.89 282.528 555.75 278.345 559.129 273.786C559.931 272.618 560.805 271.495 561.579 270.305C562.348 269.112 563.142 267.931 563.834 266.69C564.57 265.472 565.221 264.207 565.864 262.937C566.487 261.659 567.104 260.37 567.59 259.03C567.595 259.012 567.614 259.002 567.632 259.008C567.648 259.013 567.657 259.032 567.653 259.05Z",
    fill: "#DCE5FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9838 204.903C12.0247 203.478 13.9523 203.055 14.5811 204.333C20.6604 216.695 37.6167 248.611 57.3663 263.551C89.5233 287.878 116.133 332.134 103.588 359.942C103.588 359.942 7.51802 360.091 11.9838 204.903Z",
    fill: "#1877F2",
    fillOpacity: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5147 222.945C18.6127 223.249 18.757 223.627 18.8851 223.976L19.2939 225.038L20.1356 227.155L21.8613 231.375C23.034 234.179 24.2412 236.969 25.4739 239.748C27.9292 245.309 30.4794 250.827 33.1417 256.291C38.4899 267.204 44.1239 277.98 50.3262 288.425C53.4492 293.632 56.5948 298.827 59.9546 303.884C63.3146 308.939 66.7912 313.917 70.459 318.751C77.7599 328.442 85.7938 337.597 94.799 345.761C94.911 345.86 94.921 346.032 94.8215 346.144C94.7247 346.253 94.557 346.263 94.4453 346.172C89.7577 342.266 85.3645 338.014 81.1604 333.588C76.9896 329.128 73.0826 324.43 69.3033 319.637C61.8505 309.965 55.0889 299.776 48.9138 289.257C45.8159 284.002 42.893 278.648 40.0473 273.256C37.2057 267.862 34.4797 262.407 31.9122 256.878C29.3363 251.354 26.842 245.793 24.5028 240.165C23.3392 237.349 22.2013 234.522 21.0988 231.682C20.5526 230.26 20.0063 228.837 19.4823 227.406L18.7113 225.253L18.3374 224.171C18.2183 223.801 18.0937 223.466 17.9807 223.038C17.9427 222.895 18.0281 222.748 18.1718 222.71C18.3105 222.673 18.4524 222.752 18.496 222.887L18.5147 222.945Z",
    fill: "#DCE5FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M455.942 384.184H296.799V142.182C296.799 135.65 302.094 130.355 308.626 130.355H444.114C450.646 130.355 455.941 135.651 455.941 142.182L455.942 384.184Z",
    fill: "#C1484C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M438.04 384.184H278.897V142.182C278.897 135.65 284.193 130.355 290.725 130.355H426.212C432.745 130.355 438.04 135.651 438.04 142.182V384.184H438.04Z",
    fill: "#E51E25"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M357.815 384.184H219.115V220.94C219.115 214.407 224.411 209.112 230.943 209.112H345.987C352.519 209.112 357.815 214.408 357.815 220.94V384.184Z",
    fill: "#0959C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M339.912 384.184H201.213V220.94C201.213 214.407 206.508 209.112 213.04 209.112H328.084C334.617 209.112 339.912 214.408 339.912 220.94L339.912 384.184Z",
    fill: "#1877F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.317 383.933H140.803V272.106C140.803 265.574 146.098 260.279 152.63 260.279H248.489C255.021 260.279 260.317 265.574 260.317 272.106L260.317 383.933Z",
    fill: "#C1484C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242.415 383.933H122.901V272.106C122.901 265.574 128.197 260.279 134.729 260.279H230.588C237.12 260.279 242.415 265.574 242.415 272.106V383.933H242.415Z",
    fill: "#E51E25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.412 383.932H52.8975V298.904C52.8975 292.372 58.193 287.077 64.725 287.077H160.584C167.116 287.077 172.411 292.372 172.411 298.904L172.412 383.932Z",
    fill: "#0959C0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.509 383.932H34.9951V298.904C34.9951 292.372 40.2906 287.077 46.8226 287.077H142.682C149.214 287.077 154.509 292.372 154.509 298.904L154.509 383.932Z",
    fill: "#1877F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M550.278 383.932H399.552V343.389C399.552 336.857 404.848 331.561 411.38 331.561H538.451C544.983 331.561 550.278 336.857 550.278 343.389V383.932Z",
    fill: "#0959C0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M532.376 383.932H381.649V343.389C381.649 336.857 386.945 331.561 393.477 331.561H520.548C527.08 331.561 532.376 336.857 532.376 343.389V383.932Z",
    fill: "#1877F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M339.249 383.933H188.522V369.429C188.522 362.897 193.818 357.601 200.35 357.601H327.421C333.953 357.601 339.249 362.897 339.249 369.429V383.933Z",
    fill: "#7D97F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M522.451 382.255L453.661 249.578C453.275 248.834 453.566 247.913 454.312 247.527C455.057 247.141 455.977 247.433 456.363 248.178L525.153 380.854C525.539 381.599 525.247 382.519 524.502 382.905C524.286 383.017 524.044 383.076 523.803 383.076C523.231 383.076 522.713 382.762 522.451 382.255Z",
    fill: "#7D97F4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M489.771 383.269L430.974 248.172C430.639 247.403 430.993 246.504 431.762 246.169C432.532 245.835 433.43 246.188 433.765 246.957L492.562 382.054C492.725 382.426 492.732 382.84 492.583 383.218C492.434 383.597 492.147 383.894 491.774 384.056C491.581 384.141 491.377 384.183 491.167 384.183C490.561 384.183 490.013 383.824 489.771 383.269Z",
    fill: "#7D97F4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M443.48 273.889H467.329C467.854 273.889 468.28 273.463 468.28 272.937C468.28 272.412 467.854 271.986 467.329 271.986H443.48C442.954 271.986 442.528 272.412 442.528 272.937C442.528 273.463 442.954 273.889 443.48 273.889Z",
    fill: "#7D97F4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M449.853 288.663H473.702C474.227 288.663 474.653 288.237 474.653 287.712C474.653 287.187 474.227 286.76 473.702 286.76H449.853C449.327 286.76 448.901 287.186 448.901 287.712C448.901 288.237 449.327 288.663 449.853 288.663Z",
    fill: "#7D97F4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M458.257 306.354H483.624C484.15 306.354 484.576 305.928 484.576 305.403C484.576 304.877 484.15 304.452 483.624 304.452H458.257C457.732 304.452 457.306 304.877 457.306 305.403C457.306 305.928 457.732 306.354 458.257 306.354Z",
    fill: "#7D97F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M437.143 259.557H459.896C460.421 259.557 460.847 259.132 460.847 258.606C460.847 258.081 460.422 257.655 459.896 257.655H437.143C436.617 257.655 436.191 258.081 436.191 258.606C436.192 259.132 436.617 259.557 437.143 259.557Z",
    fill: "#7D97F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M466.627 326.708H494.191C494.716 326.708 495.142 326.283 495.142 325.757C495.142 325.232 494.716 324.806 494.191 324.806H466.627C466.102 324.806 465.676 325.232 465.676 325.757C465.676 326.283 466.102 326.708 466.627 326.708Z",
    fill: "#7D97F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M473.104 342.497H502.668C503.193 342.497 503.619 342.072 503.619 341.546C503.619 341.021 503.193 340.595 502.668 340.595H473.104C472.578 340.595 472.152 341.021 472.152 341.546C472.152 342.072 472.578 342.497 473.104 342.497Z",
    fill: "#7D97F4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M478.918 323.302C481.962 320.652 488.504 318.529 488.504 318.529L492.44 318.615C493.438 319.738 493.89 321.916 494.083 323.281C493.342 323.725 491.953 324.114 489.407 324.235C484.691 324.46 480.886 323.771 478.918 323.302Z",
    fill: "url(#paint0_linear_1404_813)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M478.917 323.302C480.886 323.771 484.691 324.46 489.406 324.236C491.952 324.114 493.341 323.725 494.082 323.281C494.098 323.391 494.112 323.497 494.124 323.595C494.195 324.155 493.848 324.681 493.309 324.846C489.713 325.948 481.806 325.594 478.723 325.403C478.064 325.362 477.719 324.589 478.142 324.081C478.361 323.817 478.624 323.557 478.917 323.302Z",
    fill: "url(#paint1_linear_1404_813)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M492.118 315.217V318.346C492.118 318.949 491.698 319.469 491.109 319.596C490.499 319.728 489.69 319.812 488.905 319.617C488.414 319.496 488.054 319.074 487.995 318.571L487.599 315.217L492.118 315.217Z",
    fill: "url(#paint2_linear_1404_813)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M472.217 299.181C473.438 296.463 473.089 295.241 475.506 295.511C475.796 295.544 476.038 295.6 476.242 295.673C476.394 296.122 476.404 296.617 476.24 297.089C475.629 298.847 474.352 301.851 472.008 304.809C471.516 305.43 470.763 305.791 469.97 305.804L467.304 305.849C469.832 303.828 471.204 301.436 472.217 299.181Z",
    fill: "url(#paint3_linear_1404_813)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M467.136 301.818C469.181 300.378 469.944 294.497 469.944 294.497L473.097 292.892L475.474 294.615C475.842 294.888 476.101 295.261 476.241 295.673C476.037 295.6 475.796 295.544 475.505 295.511C473.088 295.241 473.438 296.463 472.217 299.181C471.204 301.436 469.831 303.828 467.304 305.848L465.473 305.879C464.649 305.893 464.174 304.953 464.673 304.298C465.299 303.477 466.155 302.509 467.136 301.818Z",
    fill: "url(#paint4_linear_1404_813)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M471.193 289.931L473.096 292.891C473.337 293.266 473.255 293.761 472.906 294.036C472.296 294.515 471.239 295.052 469.944 294.496L466.886 292.401L471.193 289.931Z",
    fill: "url(#paint5_linear_1404_813)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M485.48 258.682C485.48 258.682 486.481 261.503 487.933 271.416C489.385 281.328 490.341 288.536 491.132 292.467C491.856 296.062 492.998 309.009 492.931 314.671C492.922 315.432 492.294 316.038 491.533 316.014L487.787 315.897C487.209 315.878 486.724 315.458 486.627 314.887C485.636 309.058 478.784 278.979 474.653 270.327C474.653 270.327 463.661 273.434 460.921 274.683C460.921 274.683 464.464 276.102 471.724 289.714C471.724 289.714 468.589 292.205 466.368 292.724C466.368 292.724 450.479 279.546 448.8 278.167C447.121 276.788 445.593 274.412 449.876 270.084C454.16 265.755 467.306 258.929 467.306 258.929L485.48 258.682Z",
    fill: "url(#paint6_linear_1404_813)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M475.26 270.634C475.288 270.634 475.315 270.628 475.342 270.616L479.262 269.105C480.947 268.302 482.041 266.577 482.051 264.71C482.052 264.605 481.967 264.52 481.862 264.519C481.739 264.52 481.671 264.603 481.671 264.708C481.662 266.43 480.652 268.021 479.098 268.762L475.178 270.272C475.083 270.318 475.043 270.431 475.088 270.526C475.121 270.594 475.189 270.634 475.26 270.634Z",
    fill: "url(#paint7_linear_1404_813)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M449.935 257.846C449.935 257.846 445.806 254.721 443.928 255.308C442.049 255.895 440.663 257.655 440.663 257.655H444.814C444.814 257.655 445.804 259.557 444.814 259.557H443.348C443.348 259.557 447.224 263.618 449.935 257.846Z",
    fill: "url(#paint8_linear_1404_813)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M456.926 228.375C456.926 228.375 452.081 247.532 445.519 255.234C445.519 255.234 447.296 257.26 449.936 257.846C449.936 257.846 460.009 249.017 463.077 242.881C466.145 236.746 456.926 228.375 456.926 228.375Z",
    fill: "url(#paint9_linear_1404_813)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M463.401 210.14L468.213 218.944H460.618C460.618 218.944 460.008 214.919 458.01 212.497L463.401 210.14Z",
    fill: "url(#paint10_linear_1404_813)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M456.106 199.656C456.106 199.656 453.695 205.196 453.533 208.103C453.371 211.011 452.744 212.897 456.106 213.483C459.468 214.068 462.3 212.393 463.834 209.497C463.834 209.497 466.238 205.035 465.699 203.207C465.16 201.379 456.106 199.656 456.106 199.656Z",
    fill: "url(#paint11_linear_1404_813)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M462.685 207.415H462.26C462.26 207.415 464.011 203.823 462.472 203.192C460.934 202.561 454.839 201.318 453.524 199.155C452.256 197.071 453.387 194.377 455.078 193.624C455.186 193.576 455.312 193.627 455.366 193.73L455.507 193.995C455.603 194.177 455.871 194.149 455.928 193.952C455.982 193.765 456.234 193.724 456.337 193.889C456.74 194.536 457.83 195.588 460.753 196.127C464.901 196.893 467.643 198.571 467.711 201.438C467.715 201.62 467.909 201.72 468.064 201.625C468.37 201.439 468.86 201.351 469.515 201.902C470.654 202.859 470.188 205.344 467.691 207.387C467.573 207.485 467.574 207.67 467.702 207.754C468.155 208.048 468.829 208.749 467.081 209.684C465.292 210.64 464.234 210.536 463.835 210.434C463.727 210.406 463.655 210.308 463.662 210.197L463.819 207.657C463.827 207.526 463.722 207.415 463.591 207.415H462.685Z",
    fill: "url(#paint12_linear_1404_813)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M462.581 207.946C462.581 207.946 463.501 204.408 465.087 205.4C466.674 206.392 464.264 209.365 462.989 209.497L462.581 207.946Z",
    fill: "url(#paint13_linear_1404_813)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M469.282 218.255C469.282 218.255 467.135 214.728 453.1 215.592C445.804 216.041 429.394 209.683 425.741 206.484C425.741 206.484 423.358 206.469 421.163 208.767C421.163 208.767 436.32 224.762 453.99 226.806C453.99 226.806 467.401 254.444 467.306 258.929C467.306 258.929 475.266 264.27 486.066 260.447C486.066 260.447 486.397 252.765 482.182 242.153C476.71 228.375 469.282 218.255 469.282 218.255Z",
    fill: "url(#paint14_linear_1404_813)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M462.918 227.789C463.016 227.789 463.1 227.714 463.108 227.615C463.116 227.51 463.038 227.418 462.934 227.41C462.866 227.404 456.128 226.856 455.078 226.738C454.974 226.727 454.879 226.801 454.867 226.905C454.855 227.01 454.93 227.104 455.035 227.116C456.091 227.235 462.835 227.783 462.903 227.789C462.908 227.789 462.913 227.789 462.918 227.789Z",
    fill: "url(#paint15_linear_1404_813)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M421.44 207.991C421.317 208.438 422.954 209.054 423.838 207.209C423.839 206.34 424.231 202.603 423.687 201.915C420.788 198.251 415.262 193.728 415.262 193.728C414.39 194.653 415.167 195.503 415.167 195.503L417.863 198.114C417.356 199.116 416.724 199.968 416.456 201.167C416.254 202.075 416.433 203.03 416.917 203.832C417.403 204.637 418.064 205.682 418.682 206.496C419.853 208.037 421.44 207.991 421.44 207.991Z",
    fill: "url(#paint16_linear_1404_813)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.685 286.472C130.686 286.387 130.68 286.301 130.659 286.215C129.381 281.148 123.037 277.992 123.037 277.992L121.413 278.12C120.867 278.162 120.406 278.543 120.253 279.068C119.071 283.129 119.29 285.615 119.515 286.708C119.517 286.711 119.519 286.712 119.522 286.714C121.595 286.899 125.863 287.02 130.685 286.472Z",
    fill: "url(#paint17_linear_1404_813)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M119.522 286.714C119.634 287.121 119.935 287.438 120.319 287.519C123.269 288.139 127.957 287.64 129.926 287.383C130.36 287.326 130.677 286.924 130.684 286.471C125.863 287.02 121.595 286.899 119.522 286.714Z",
    fill: "url(#paint18_linear_1404_813)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.883 273.514L120.577 279.569C120.669 280.013 121.01 280.345 121.423 280.384C121.929 280.432 122.648 280.46 123.372 280.353C124.021 280.258 124.473 279.598 124.358 278.891L126.047 273.514H121.883Z",
    fill: "url(#paint19_linear_1404_813)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.001 259.634C163.519 259.565 162.234 259.272 161.571 259.001C161.569 259.248 161.571 259.499 161.578 259.76C161.587 260.038 161.793 260.26 162.046 260.258L175.678 260.17C176.113 260.167 176.368 259.663 176.179 259.264C174.392 259.411 169.839 259.742 166.001 259.634Z",
    fill: "url(#paint20_linear_1404_813)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M176.181 259.264C176.185 259.255 176.184 259.258 176.188 259.249C175.029 257.598 171.963 254.155 165.797 252.676L163.532 252.605C163.122 252.592 162.752 252.836 162.597 253.215C162.213 254.153 161.588 256.118 161.571 259.001C162.235 259.272 163.519 259.565 166.002 259.634C169.841 259.742 174.394 259.411 176.181 259.264Z",
    fill: "url(#paint21_linear_1404_813)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M164.143 248.461C164.115 248.678 163.61 251.956 163.414 253.227C163.367 253.529 163.515 253.815 163.773 253.921C164.234 254.112 164.991 254.38 165.704 254.431C166.089 254.458 166.451 254.182 166.565 253.776L167.96 248.799L164.143 248.461Z",
    fill: "url(#paint22_linear_1404_813)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.084 214.654C136.084 214.654 132.829 219.536 131.744 226.589C130.746 233.077 122.242 269.507 120.888 275.293C120.785 275.733 121.063 276.165 121.503 276.265C122.337 276.453 123.676 276.702 124.774 276.658C125.357 276.634 125.873 276.275 126.105 275.738L146.392 228.759C146.392 228.759 159.883 226.16 164.836 232.014C167.809 235.526 165.854 241.711 163.209 250.458C163.209 250.458 166.464 252.086 168.634 251.001C168.634 251.001 178.748 235.193 174.602 225.504C172.682 221.018 164.396 216.597 156.157 215.739L136.084 214.654Z",
    fill: "url(#paint23_linear_1404_813)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M136.083 214.654L140.965 171.254C140.965 171.254 162.123 171.254 175.685 178.849L158.129 215.466C157.188 217.43 155.205 218.69 153.027 218.68C149.305 218.662 143.106 217.998 136.083 214.654Z",
    fill: "url(#paint24_linear_1404_813)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M193.317 167.186C193.317 167.186 191.961 181.019 175.686 178.849C175.686 178.849 169.439 185.74 169.308 191.788C169.308 191.788 199.013 199.464 196.301 168.542L193.317 167.186Z",
    fill: "url(#paint25_linear_1404_813)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M133.914 209.771C133.914 209.771 136.084 205.974 139.338 206.516C142.593 207.059 144.221 210.314 144.221 210.314C144.221 210.314 140.966 211.941 138.796 213.026C136.626 214.111 132.829 213.026 133.914 209.771Z",
    fill: "url(#paint26_linear_1404_813)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M140.424 184.817C140.424 184.817 112.757 197.294 133.914 209.771L134.372 212.478C134.372 212.478 117.548 214.919 116.825 195.395C116.283 180.748 140.966 171.254 140.966 171.254L140.424 184.817Z",
    fill: "url(#paint27_linear_1404_813)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M158.21 164.741L154.224 173.265C154.224 173.265 158.662 176.517 163.176 175.246L164.34 163.143L158.21 164.741Z",
    fill: "url(#paint28_linear_1404_813)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M168.03 155.464C168.112 155.618 169.789 167.009 169.789 167.009L163.265 167.828L160.071 157.268C160.071 157.268 166.656 152.893 168.03 155.464Z",
    fill: "url(#paint29_linear_1404_813)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M162.475 158.34C162.288 158.565 162.215 158.863 162.278 159.149L163.505 164.757C163.524 164.842 163.553 164.923 163.594 165C163.823 165.423 164.659 166.709 165.954 165.777C167.058 164.983 168.083 164.269 168.971 164.131C169.489 164.05 169.97 164.416 170.045 164.935C170.198 166.005 170.464 168.169 170.43 170.124C170.421 170.615 170.033 171.013 169.543 171.043C168.252 171.12 165.725 171.197 163.64 170.8C163.297 170.735 163.02 170.488 162.915 170.156C162.453 168.692 161.141 164.595 160.593 163.496C160.084 162.475 158.573 162.286 157.874 162.255C157.608 162.243 157.362 162.122 157.19 161.92C156.675 161.313 155.873 159.963 157.458 158.668C157.852 158.346 157.905 157.759 157.591 157.358C157.029 156.64 156.546 155.485 157.778 154.292C159.026 153.085 160.419 153.409 161.3 153.83C161.69 154.017 162.175 153.943 162.458 153.616C162.584 153.471 162.77 153.374 163.043 153.408C163.557 153.473 164.022 153.139 164.09 152.625C164.206 151.743 164.69 150.71 166.254 150.429C169.124 149.913 170.515 152.797 170.437 154.809C170.36 156.822 167.217 157.205 165.441 156.847C164.137 156.585 162.991 157.719 162.475 158.34Z",
    fill: "url(#paint30_linear_1404_813)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M161.068 165.564C161.068 165.564 161.052 162.05 159.635 161.702C158.217 161.353 156.67 162.361 157.859 164.48C159.337 167.115 161.068 165.564 161.068 165.564Z",
    fill: "url(#paint31_linear_1404_813)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M171.074 158.506L216.102 151.453L215.559 165.558L171.074 161.76V158.506Z",
    fill: "url(#paint32_linear_1404_813)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M214.555 150.957C214.316 153.75 214.551 162.54 214.682 165.437C214.705 165.961 215.137 166.372 215.662 166.372H216.424C217.02 166.372 217.532 165.939 217.628 165.35C218.468 160.162 218.896 155.283 218.609 150.943C218.577 150.464 218.172 150.097 217.693 150.097H215.496C215.006 150.097 214.596 150.469 214.555 150.957Z",
    fill: "url(#paint33_linear_1404_813)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M171.933 157.692H170.602C170.39 157.692 170.21 157.841 170.164 158.048C169.874 159.366 170.091 161.356 170.204 162.187C170.233 162.409 170.422 162.574 170.645 162.574H171.489C171.716 162.574 171.907 162.403 171.932 162.178L172.376 158.187C172.405 157.923 172.198 157.692 171.933 157.692Z",
    fill: "url(#paint34_linear_1404_813)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M193.316 167.186C193.316 167.186 193.562 164.044 193.982 163.716C194.402 163.388 197.656 160.133 198.199 160.133C198.742 160.133 199.284 161.218 198.199 161.76C197.114 162.303 196.844 163.96 196.844 163.96L199.788 164.212C199.788 164.212 197.657 168.27 196.571 168.813C195.487 169.355 193.316 167.186 193.316 167.186Z",
    fill: "url(#paint35_linear_1404_813)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M356.745 129.475C356.743 129.41 356.748 129.345 356.764 129.279C357.745 125.392 361.753 123.4 361.753 123.4L363.681 123.551C364.789 126.977 365.504 128.649 365.326 129.585C365.321 129.611 365.313 129.636 365.306 129.661C363.716 129.803 360.442 129.896 356.745 129.475Z",
    fill: "url(#paint36_linear_1404_813)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M365.306 129.661C365.22 129.973 364.989 130.217 364.694 130.279C362.432 130.754 358.836 130.371 357.326 130.174C356.993 130.131 356.75 129.822 356.744 129.475C360.442 129.896 363.716 129.803 365.306 129.661Z",
    fill: "url(#paint37_linear_1404_813)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M360.165 120.4L361.009 124.463C361.071 124.761 361.3 124.984 361.577 125.01C361.916 125.042 362.399 125.061 362.885 124.989C363.321 124.925 363.624 124.483 363.547 124.008L362.96 120.4H360.165Z",
    fill: "url(#paint38_linear_1404_813)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M381.688 129.627C379.629 129.57 378.564 129.327 378.013 129.102C378.012 129.307 378.013 129.515 378.02 129.731C378.027 129.962 378.198 130.146 378.408 130.145L389.713 130.072C390.074 130.069 390.285 129.651 390.128 129.32C388.646 129.442 384.871 129.716 381.688 129.627Z",
    fill: "url(#paint39_linear_1404_813)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M390.128 129.32C390.115 129.291 390.103 129.262 390.084 129.235C389.085 127.84 386.542 125.061 381.517 123.857L379.107 123.781C379.107 123.781 378.033 125.646 378.013 129.102C378.564 129.327 379.629 129.57 381.688 129.627C384.871 129.716 388.646 129.442 390.128 129.32Z",
    fill: "url(#paint40_linear_1404_813)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M378.659 120.127C378.686 120.307 379.016 123.038 379.144 124.097C379.175 124.348 379.357 124.543 379.587 124.57C379.997 124.619 380.661 124.664 381.242 124.545C381.556 124.481 381.783 124.18 381.783 123.829V119.543L378.659 120.127Z",
    fill: "url(#paint41_linear_1404_813)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M361.776 67.0394C361.776 67.0394 357.919 101.327 360.062 122.757C360.062 122.757 362.633 122.757 363.919 122.329C363.919 122.329 367.928 88.8038 369.224 79.2107C369.273 78.8491 369.79 78.8327 369.861 79.1905C371.46 87.2612 377.745 118.911 378.492 121.9C378.492 121.9 380.635 122.757 382.349 121.9C382.349 121.9 378.92 76.04 376.349 67.8967L361.776 67.0394Z",
    fill: "url(#paint42_linear_1404_813)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M354.062 27.1799C354.062 27.1799 370.348 24.6083 383.206 28.0372L382.349 41.3235C382.349 41.3235 378.92 59.7532 376.349 67.8968C376.349 67.8968 366.491 69.6111 361.776 67.0395C361.776 67.0395 357.919 43.8953 355.776 40.4662C355.776 40.4662 353.633 31.4657 354.062 27.1799Z",
    fill: "url(#paint43_linear_1404_813)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M365.376 15.4685L363.753 26.4405C363.753 26.4405 368.286 28.5228 371.46 26.3513L370.777 18.6077L365.376 15.4685Z",
    fill: "url(#paint44_linear_1404_813)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M372.361 8.32387C372.412 8.41662 373.39 13.9494 373.992 17.3741C374.24 18.7891 373.2 20.1037 371.766 20.1885L370.452 20.2664C368.039 20.4091 365.914 18.6911 365.548 16.3015L364.599 10.0975C364.599 10.0975 371.12 6.07358 372.361 8.32387Z",
    fill: "url(#paint45_linear_1404_813)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M363.183 10.113C362.68 9.48688 362.241 8.47424 363.313 7.40952C364.399 6.33163 365.63 6.60022 366.412 6.96186C366.757 7.1219 367.183 7.0511 367.429 6.75997C367.539 6.63065 367.701 6.54288 367.942 6.56979C368.396 6.6207 368.802 6.3208 368.856 5.867C368.948 5.08901 369.363 4.17293 370.738 3.90697C373.261 3.41923 374.52 5.94424 374.475 7.71907C374.43 9.49361 371.664 9.86695 370.095 9.57231C368.943 9.3558 367.946 10.3687 367.498 10.9217C367.336 11.1224 367.275 11.3855 367.334 11.6368L367.732 13.3514C367.456 13.8845 367.185 14.4287 366.797 14.8833C366.517 15.2107 366.211 15.3916 365.886 15.4679C365.416 14.5922 364.1 14.4439 363.489 14.4243C363.255 14.4167 363.036 14.3137 362.882 14.1372C362.421 13.6083 361.699 12.428 363.081 11.2687C363.425 10.9811 363.464 10.4627 363.183 10.113Z",
    fill: "url(#paint46_linear_1404_813)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M366.342 17.3039C366.342 17.3039 366.287 14.2081 365.034 13.9172C363.781 13.6264 362.429 14.5323 363.501 16.3858C364.834 18.6914 366.342 17.3039 366.342 17.3039Z",
    fill: "url(#paint47_linear_1404_813)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M361.393 41.9791C361.393 41.9791 324.592 31.9618 342.865 6.2002L344.101 7.95074C344.101 7.95074 338.596 25.3994 356.833 27.0572C356.833 27.0572 361.557 39.2396 361.393 41.9791Z",
    fill: "url(#paint48_linear_1404_813)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M342.741 6.33278C342.741 6.33278 342.326 1.35881 344.813 0.944508C347.3 0.529913 348.129 3.0169 348.544 4.26039C348.958 5.50388 344.813 7.99086 343.985 7.99086C343.155 7.99086 342.741 6.33278 342.741 6.33278Z",
    fill: "url(#paint49_linear_1404_813)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M374.668 43.2226C374.668 43.2226 411.469 33.2053 393.196 7.44397L391.96 9.19451C391.96 9.19451 397.465 26.6432 379.228 28.3013C379.228 28.3007 374.505 40.4831 374.668 43.2226Z",
    fill: "url(#paint50_linear_1404_813)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M393.32 7.57631C393.32 7.57631 393.735 2.60234 391.248 2.18804C388.761 1.77344 387.932 4.26043 387.517 5.50392C387.103 6.74741 391.248 9.23439 392.077 9.23439C392.906 9.2341 393.32 7.57631 393.32 7.57631Z",
    fill: "url(#paint51_linear_1404_813)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M252.094 356.902H255.081V324.608H252.094V356.902Z",
    fill: "url(#paint52_linear_1404_813)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M240.51 357.524H266.665V356.629C266.665 356.05 266.196 355.581 265.617 355.581H241.559C240.98 355.581 240.51 356.05 240.51 356.629V357.524Z",
    fill: "url(#paint53_linear_1404_813)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M235.564 323.417C235.564 325.294 237.1 326.83 238.977 326.83H267.1C268.977 326.83 270.513 325.294 270.513 323.417V320.331C270.513 318.454 268.977 316.918 267.1 316.918H238.977C237.1 316.918 235.564 318.454 235.564 320.331V323.417Z",
    fill: "url(#paint54_linear_1404_813)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M270.22 351.181C270.22 351.181 278.747 357.327 277.266 361.456C277.266 361.456 267.936 357.431 266.809 354.26C265.682 351.089 267 349.689 267 349.689L270.22 351.181Z",
    fill: "url(#paint55_linear_1404_813)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M268.939 346.03L267.545 350.06C267.335 350.669 267.545 351.361 268.089 351.705C268.362 351.877 268.734 352.037 269.243 352.152C269.962 352.315 270.703 351.983 271.049 351.332L272.716 348.192L268.939 346.03Z",
    fill: "url(#paint56_linear_1404_813)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M255.37 309.748C255.37 309.748 272.885 312.784 280.398 319.724C287.911 326.664 273.502 348.804 273.502 348.804C273.502 348.804 271.141 348.789 268.28 346.337C268.28 346.337 276.823 329.687 269.46 324.831C261.183 319.372 251.643 318.142 251.643 318.142L255.2 310.283L255.37 309.748Z",
    fill: "url(#paint57_linear_1404_813)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M275.785 359.173C273.909 358.304 268.599 354.588 267.704 354.424C266.809 354.26 265.257 355.312 265.257 355.312C265.257 355.312 264.879 355.991 265.283 357.176C266.53 358.684 269.297 361.558 273.017 362.63C275.753 363.418 277.668 362.683 278.86 361.824C278.204 360.824 277.034 359.751 275.785 359.173Z",
    fill: "url(#paint58_linear_1404_813)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M273.017 362.629C269.297 361.558 266.53 358.684 265.283 357.176C265.556 357.976 266.186 359.007 267.531 360.216C270.866 363.214 277.236 364.294 278.593 364.086C279.68 363.919 279.577 362.916 278.859 361.823C277.667 362.683 275.753 363.417 273.017 362.629Z",
    fill: "url(#paint59_linear_1404_813)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M263.666 352.689C263.687 353.205 264.743 354.978 265.36 355.972C265.654 356.444 266.168 356.733 266.724 356.735C267.077 356.735 267.482 356.705 267.85 356.599C268.403 356.44 268.713 355.851 268.552 355.3L267.346 351.181L263.666 352.689Z",
    fill: "url(#paint60_linear_1404_813)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M238.51 304.49C238.51 304.49 234.62 314.891 238.51 318.054C242.399 321.217 251.679 324.778 253.751 331.078C255.824 337.378 259.342 349.621 264.049 353.957C264.049 353.957 267.357 353.637 268.595 352.319C268.595 352.319 265.914 334.042 264.145 329.352C262.614 325.29 260.358 319.428 256.034 316.152C254.797 315.214 255.012 313.728 255.586 312.285L256.631 309.657L238.51 304.49Z",
    fill: "url(#paint61_linear_1404_813)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M279.078 296.339C272.556 296.732 274.588 286.312 274.705 285.898L264.807 292.89C264.807 292.89 265.331 298.462 273.561 301.385C275.643 302.124 277.546 302.157 279.228 301.795C278.511 299.703 278.657 297.825 279.078 296.339Z",
    fill: "url(#paint62_linear_1404_813)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M291.688 293.203C289.257 291.512 286.504 293.203 286.504 293.203C283.255 295.328 280.85 296.232 279.077 296.339C278.656 297.825 278.51 299.703 279.228 301.795C282.868 301.013 285.473 298.378 286.605 297.026C287.012 296.54 287.734 296.455 288.232 296.848C288.738 297.248 289.229 297.795 289.14 298.371C288.964 299.507 290.282 299.868 290.382 299.456C290.481 299.044 289.931 296.602 289.931 296.602C289.931 296.602 292.566 299.253 293.595 300.271C294.624 301.29 295.918 300.271 295.918 300.271C295.918 300.271 294.118 294.893 291.688 293.203Z",
    fill: "url(#paint63_linear_1404_813)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M248.666 269.807C248.666 269.807 258.155 266.008 275.813 280.586C275.813 280.586 277.288 283.639 275.679 286.356C274.07 289.074 258.738 302.314 256.632 309.657C256.632 309.657 247.498 312.625 238.052 305.587C238.051 305.587 238.885 285.152 248.666 269.807Z",
    fill: "url(#paint64_linear_1404_813)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M267.424 266.416L262.753 272.079C262.289 272.641 262.187 273.423 262.508 274.077C263.156 275.4 264.694 277.325 268.106 277.059C269.121 276.98 270.019 276.368 270.463 275.451L273.729 268.7L267.424 266.416Z",
    fill: "url(#paint65_linear_1404_813)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M241.321 294.058C240.219 289.572 251.376 279.571 251.376 279.571L248.667 269.807C248.667 269.807 224.575 285.845 230.714 298.742C231.595 300.591 232.763 301.886 234.119 302.752C236.059 297.53 239.15 295.136 241.321 294.058Z",
    fill: "url(#paint66_linear_1404_813)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.314 293.405C241.195 293.405 241.087 293.324 241.058 293.204C239.931 288.617 250.733 278.871 251.194 278.458C251.302 278.361 251.468 278.37 251.566 278.478C251.663 278.587 251.654 278.754 251.546 278.851C251.435 278.95 240.519 288.797 241.57 293.079C241.605 293.22 241.518 293.363 241.377 293.397C241.356 293.402 241.334 293.405 241.314 293.405Z",
    fill: "url(#paint67_linear_1404_813)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M258.219 293.672C258.219 293.672 244.991 298.808 241.762 294.945C241.544 294.683 241.401 294.384 241.321 294.058C239.15 295.136 236.059 297.531 234.119 302.752C241.076 307.198 252.968 300.279 256.183 298.24C256.712 297.904 257.347 297.786 257.96 297.914C259.201 298.171 261.343 298.549 262.498 298.371C264.189 298.111 266.617 304.073 269.357 302.234C269.357 302.234 267.01 291.869 258.219 293.672Z",
    fill: "url(#paint68_linear_1404_813)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M277.587 258.099C277.621 258.232 276.934 266.322 276.557 270.728C276.499 271.411 276.136 272.031 275.571 272.419C275.005 272.806 274.294 272.921 273.636 272.728L270.704 271.867C269.696 271.571 268.825 270.925 268.252 270.044C267.971 269.614 267.69 269.183 267.372 268.695L268.777 257.965C268.777 257.964 276.8 255.052 277.587 258.099Z",
    fill: "url(#paint69_linear_1404_813)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M277.006 252.365C275.235 252.258 274.471 253.287 274.142 254.207C273.97 254.685 273.422 254.93 272.964 254.71C272.624 254.547 272.365 254.618 272.175 254.77C271.841 255.036 271.371 255.04 271.048 254.76C270.247 254.07 268.817 253.269 267.129 254.259C265.469 255.234 265.765 256.639 266.202 257.533C266.421 257.983 266.228 258.519 265.773 258.725C263.595 259.707 264.218 261.452 264.612 262.193C264.723 262.402 264.913 262.555 265.142 262.62C265.839 262.816 267.457 263.397 267.739 264.632C267.763 264.74 267.788 264.878 267.813 265.028C268.696 264.775 269.597 264.62 270.52 264.573L270.614 260.43C270.62 260.165 270.744 259.916 270.955 259.755C271.621 259.247 273.171 258.263 274.518 258.892C276.29 259.719 279.685 260.119 280.279 258.026C280.873 255.934 280.148 252.554 277.006 252.365Z",
    fill: "url(#paint70_linear_1404_813)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M267.709 266.921C267.709 266.921 268.588 263.231 267.189 262.505C265.791 261.778 263.912 262.441 264.618 264.967C265.498 268.108 267.709 266.921 267.709 266.921Z",
    fill: "url(#paint71_linear_1404_813)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M264.995 303.8C265.017 303.801 265.038 303.801 265.059 303.801L292.813 303.771C293.499 303.77 294.055 303.214 294.054 302.528C294.054 301.841 293.495 301.274 292.81 301.287L265.056 301.317C264.37 301.318 263.815 301.875 263.815 302.561C263.816 303.225 264.339 303.767 264.995 303.8Z",
    fill: "url(#paint72_linear_1404_813)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M317.764 278.601H294.649C292.944 278.601 291.392 279.585 290.665 281.127L279.979 303.785H308.704C309.803 303.785 310.79 303.113 311.194 302.092L319.48 281.125C319.959 279.913 319.066 278.601 317.764 278.601Z",
    fill: "url(#paint73_linear_1404_813)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M301.479 290.218C300.979 291.774 301.349 293.285 302.306 293.593C303.263 293.902 304.445 292.89 304.946 291.334C305.447 289.778 305.077 288.266 304.12 287.958C303.163 287.65 301.98 288.662 301.479 290.218Z",
    fill: "#91B3FA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M314.016 363.327C314.17 363.327 314.326 363.297 314.476 363.235C315.068 362.989 315.341 362.325 315.087 361.752L290.627 306.702C290.372 306.129 289.686 305.864 289.094 306.111C288.503 306.357 288.229 307.021 288.484 307.594L312.944 362.644C313.134 363.071 313.564 363.327 314.016 363.327Z",
    fill: "#BDD0FB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M286.46 363.327C286.913 363.327 287.343 363.071 287.533 362.644L311.993 307.594C312.247 307.021 311.974 306.357 311.382 306.11C310.791 305.864 310.105 306.128 309.85 306.701L285.39 361.752C285.135 362.324 285.409 362.989 286.001 363.235C286.15 363.297 286.307 363.327 286.46 363.327Z",
    fill: "#BDD0FB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M238.301 363.327C238.455 363.327 238.611 363.297 238.761 363.235C239.353 362.989 239.627 362.324 239.372 361.751L214.912 306.701C214.657 306.129 213.972 305.864 213.38 306.11C212.788 306.357 212.514 307.021 212.769 307.594L237.229 362.644C237.419 363.071 237.849 363.327 238.301 363.327Z",
    fill: "#BDD0FB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M210.746 363.327C211.198 363.327 211.628 363.071 211.818 362.644L236.278 307.594C236.533 307.021 236.259 306.357 235.668 306.11C235.076 305.864 234.39 306.128 234.135 306.701L209.675 361.752C209.421 362.324 209.694 362.989 210.285 363.235C210.436 363.297 210.592 363.327 210.746 363.327Z",
    fill: "#BDD0FB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M207.877 305.002C207.815 304.641 207.9 304.268 208.109 303.984C208.318 303.7 208.629 303.536 208.958 303.536H320.234C320.666 303.536 321.068 303.782 321.301 304.19C321.534 304.597 321.565 305.109 321.384 305.548L320.178 308.47C319.902 309.139 319.304 309.568 318.645 309.568H209.721C209.109 309.568 208.583 309.081 208.466 308.408L207.877 305.002Z",
    fill: "#BDD0FB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M270.469 208.487H272.448V187.082H270.469V208.487Z",
    fill: "url(#paint74_linear_1404_813)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M262.791 208.9H280.127V208.306C280.127 207.923 279.816 207.612 279.433 207.612H263.486C263.102 207.612 262.791 207.923 262.791 208.306L262.791 208.9Z",
    fill: "url(#paint75_linear_1404_813)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M260.217 186.338C260.217 187.509 261.175 188.467 262.346 188.467H279.886C281.056 188.467 282.014 187.509 282.014 186.338V184.414C282.014 183.243 281.056 182.285 279.886 182.285H262.346C261.175 182.285 260.217 183.243 260.217 184.414V186.338Z",
    fill: "url(#paint76_linear_1404_813)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M286.072 172.808C286.072 172.808 289.013 173.264 292.32 175.475C292.84 175.823 293.126 176.429 293.047 177.051C292.651 180.187 291.023 190.339 285.654 200.255C285.371 200.778 285.29 201.386 285.415 201.968L286.348 206.309L288.077 207.93H283.622L280.655 199.902L281.924 199.501C282.907 199.19 283.582 198.286 283.6 197.254L283.749 188.643C283.622 184.806 286.101 182.159 286.101 182.159L278.986 181.812L286.072 172.808Z",
    fill: "url(#paint77_linear_1404_813)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M289.817 208.714C290.223 209.245 285.45 209.946 283.039 208.784C283.039 208.784 279.696 202.968 279.696 199.974C279.696 199.974 279.961 199.363 281.924 199.501C281.924 199.501 283.046 206.388 284.232 207.159C285.417 207.93 287.547 207.237 287.547 207.237C287.547 207.237 289.219 207.93 289.817 208.714Z",
    fill: "url(#paint78_linear_1404_813)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M279.886 182.285C279.924 182.219 287.547 181.368 287.547 181.368C287.547 181.368 287.298 183.686 288.077 186.877C288.857 190.068 300.049 203.891 300.049 203.891L298.876 207.611C302.504 208.875 306.074 209.077 309.586 208.256L302.313 203.891C302.313 203.891 295.506 180.695 291.337 176.557L283.696 173.914L279.886 182.285Z",
    fill: "url(#paint79_linear_1404_813)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M262.79 168.788C262.79 168.788 258.398 175.321 258.038 178.301C257.677 181.281 259.241 182.491 263.849 182.691C268.457 182.89 280.76 182.887 280.76 182.887L291.26 173.914C291.26 173.914 283.608 171.183 281.618 170.411C279.629 169.639 262.79 168.788 262.79 168.788Z",
    fill: "url(#paint80_linear_1404_813)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M299.319 206.358C299.319 206.358 298.056 207.582 298.909 208.944C298.909 208.944 308.918 210.718 311.635 209.913C311.635 209.913 311.071 208.625 308.011 207.159L308.237 207.332C308.523 207.552 308.355 208.008 307.996 207.988C305.979 207.873 301.806 207.504 299.319 206.358Z",
    fill: "url(#paint81_linear_1404_813)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M274.669 167.923C274.669 167.923 279.783 163.053 282.301 159.828C283.662 158.084 284.089 155.789 283.46 153.668C282.31 149.796 280.267 145.785 280.081 145.161C279.796 144.204 274.061 144.244 274.061 144.244C274.061 144.244 262.776 151.568 258.343 163.974L263.322 165.524C263.322 165.524 266.268 160.581 269.18 157.438C269.18 157.438 264.142 164.093 263.965 166.817L274.669 167.923Z",
    fill: "url(#paint82_linear_1404_813)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M280.776 139.814C280.716 140.013 279.219 144.975 279.102 145.078C278.985 145.181 275.819 145.351 274.33 144.333L276.857 139.042L280.776 139.814Z",
    fill: "url(#paint83_linear_1404_813)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M278.316 129.392C278.316 129.392 281.018 130.533 282.856 134.437C284.693 138.342 283.321 140.145 281.598 140.392C279.874 140.64 277.297 140.602 274.571 138.08C271.845 135.557 274.804 128.039 278.316 129.392Z",
    fill: "url(#paint84_linear_1404_813)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M276.403 135.995C276.403 135.995 274.364 130.283 279.429 130.215L280.621 131.048C280.621 131.048 282.479 127.881 279.429 126.369C276.379 124.857 271.828 126.203 270.53 130.312C269.232 134.422 269.992 137.075 272.151 139.041C274.311 141.007 275.201 138.778 275.201 138.778C275.201 138.778 274.025 136.939 274.503 135.956C274.982 134.972 276.086 136.159 276.086 136.159L276.403 135.995Z",
    fill: "url(#paint85_linear_1404_813)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M275.835 136.632C275.835 136.632 274.805 133.689 273.429 134.861C272.054 136.033 274.547 137.579 275.523 138.08L275.835 136.632Z",
    fill: "url(#paint86_linear_1404_813)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M285.088 168.285L281.331 164.663L276.132 166.859C276.132 166.859 270.958 167.661 267.997 166.859C265.035 166.057 265.035 166.057 265.035 166.057L258.343 163.974L257.292 166.944C257.025 167.699 257.293 168.536 257.945 168.999C258.524 169.411 259.203 169.863 259.635 170.052C260.517 170.438 281.361 169.785 281.361 169.785L285.088 168.285Z",
    fill: "url(#paint87_linear_1404_813)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M270.927 130.957C271.578 130.291 271.155 129.167 270.236 129.024C267.266 128.561 262.739 129.033 260.838 135.389C258.696 142.549 257.302 146.129 255.871 146.757C254.931 147.169 254.871 148.474 255.807 148.894C256.499 149.205 257.49 149.315 258.908 149.003C269.85 146.596 267.107 134.858 270.927 130.957Z",
    fill: "url(#paint88_linear_1404_813)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M270.867 169.993C270.884 169.994 270.9 169.994 270.917 169.994L292.715 169.97C293.254 169.97 293.69 169.533 293.689 168.994C293.689 168.455 293.25 168.009 292.712 168.019L270.915 168.043C270.376 168.043 269.94 168.48 269.94 169.019C269.941 169.541 270.352 169.967 270.867 169.993Z",
    fill: "url(#paint89_linear_1404_813)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31 150.202H294.157C292.818 150.202 291.599 150.975 291.028 152.186L282.635 169.981H305.195C306.058 169.981 306.834 169.454 307.151 168.652L313.658 152.185C314.034 151.233 313.333 150.202 312.31 150.202Z",
    fill: "url(#paint90_linear_1404_813)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M299.522 159.326C299.129 160.548 299.419 161.735 300.171 161.977C300.923 162.219 301.851 161.424 302.245 160.202C302.638 158.98 302.348 157.793 301.596 157.551C300.844 157.309 299.915 158.104 299.522 159.326Z",
    fill: "#91B3FA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M240.402 170.789C240.351 170.542 240.42 170.286 240.591 170.092C240.762 169.898 241.017 169.785 241.285 169.785H332.246C332.599 169.785 332.928 169.954 333.118 170.233C333.309 170.512 333.334 170.862 333.186 171.163L332.2 173.162C331.975 173.62 331.485 173.914 330.947 173.914H241.909C241.409 173.914 240.978 173.581 240.883 173.12L240.402 170.789Z",
    fill: "#7D97F4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M327.148 212.938C327.253 212.938 327.36 212.916 327.463 212.871C327.868 212.693 328.055 212.212 327.881 211.798L311.14 171.979C310.966 171.565 310.496 171.374 310.091 171.551C309.686 171.73 309.499 172.21 309.673 172.624L326.415 212.444C326.544 212.753 326.839 212.938 327.148 212.938Z",
    fill: "#7D97F4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M308.288 212.938C308.597 212.938 308.892 212.753 309.022 212.443L325.763 172.624C325.937 172.21 325.75 171.73 325.345 171.551C324.94 171.373 324.471 171.564 324.296 171.979L307.555 211.798C307.381 212.212 307.568 212.693 307.973 212.871C308.076 212.916 308.183 212.938 308.288 212.938Z",
    fill: "#7D97F4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M261.223 212.938C261.328 212.938 261.435 212.916 261.538 212.871C261.943 212.693 262.13 212.212 261.956 211.798L245.215 171.979C245.041 171.565 244.572 171.374 244.166 171.551C243.761 171.73 243.574 172.21 243.748 172.624L260.49 212.444C260.619 212.753 260.914 212.938 261.223 212.938Z",
    fill: "#7D97F4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M242.363 212.938C242.672 212.938 242.967 212.753 243.097 212.443L259.838 172.624C260.012 172.21 259.825 171.73 259.42 171.551C259.015 171.373 258.546 171.564 258.371 171.979L241.63 211.798C241.456 212.212 241.643 212.693 242.048 212.871C242.151 212.916 242.258 212.938 242.363 212.938Z",
    fill: "#7D97F4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6079 313.669C10.6079 313.669 0.993518 318.995 0.197975 328.009C-0.597567 337.023 0.131848 374.436 19.4112 383.644C38.6906 392.853 64.21 390.731 73.9783 389.724C83.7466 388.718 89.1627 382.079 90.3725 377.508C91.5824 372.937 93.5365 355.91 83.2606 350.417C72.9844 344.925 62.1918 336.51 51.407 328.317C40.6223 320.123 22.1399 306.748 10.6079 313.669Z",
    fill: "#E51E25"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2304 353.524C80.2304 353.524 77.6354 353.662 77.3174 359C77.3174 359 83.3344 364.395 91.4625 365.678C92.0728 365.775 90.6093 361.513 90.3896 360.936C89.3424 358.189 86.0464 356.42 80.2304 353.524Z",
    fill: "url(#paint91_linear_1404_813)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0063 347.247H53.6115C55.4147 347.247 57.138 346.52 58.3929 345.225C62.7065 340.774 73.4872 330.297 82.0087 327.409C83.395 326.94 84.9092 327.607 85.5303 328.932C87.3092 332.727 89.805 341.56 83.8948 354.929C83.2399 356.411 81.382 357.04 80.0352 356.14C79.6523 355.884 79.3755 355.547 79.2049 355.127L79.8547 339.501C79.8547 339.501 65.5183 352.04 63.0263 354.459C60.5347 356.879 47.868 355.404 51.0063 347.247Z",
    fill: "url(#paint92_linear_1404_813)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M103.947 386.218C101.652 384.208 97.9959 381.951 92.7177 381.304L90.9326 382.396C90.9326 382.396 92.0708 384.075 94.1502 385.849C96.0613 386.959 99.0124 388.462 101.459 388.788C103.838 389.105 104.189 387.668 103.947 386.218Z",
    fill: "url(#paint93_linear_1404_813)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3896 360.936C88.9758 361.393 88.354 363.396 84.7669 362.071C81.2966 360.79 78.7165 359.138 77.3891 358.185C77.3595 358.443 77.3344 358.713 77.3174 359C77.3174 359 83.6618 365.035 91.7899 366.319C92.4002 366.415 92.8836 365.806 92.6635 365.229C92.2691 364.193 91.5573 362.622 90.3896 360.936Z",
    fill: "#7D97F4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M105.675 387.936C105.223 387.422 104.645 386.831 103.946 386.218C104.188 387.668 103.837 389.105 101.458 388.788C99.0119 388.462 96.0608 386.959 94.1497 385.849C96.5451 387.891 100.19 390.06 104.789 389.933C105.811 389.904 106.35 388.703 105.675 387.936Z",
    fill: "#7D97F4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2067 351.209L76.8499 351.487C76.8499 351.487 91.4941 363.603 94.1502 382.078C94.1502 382.078 94.5911 383.437 91.9441 383.669C91.9441 383.669 83.0904 377.887 77.3174 367.663C70.2389 355.127 56.2152 360.77 56.2152 360.77C51.6075 357.448 45.0966 356.772 40.1914 355.665L51.2067 351.209Z",
    fill: "url(#paint94_linear_1404_813)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2917 350.983C53.2917 350.983 50.1526 342.45 49.4779 334.159C49.4779 334.159 51.7744 332.185 53.2098 331.333C53.6747 331.057 53.8503 330.474 53.6153 329.987C52.56 327.801 46.1778 319.217 45.6997 319.097C43.1012 318.449 32.4441 313.382 24.9384 323.648C21.717 328.054 25.5777 341.618 40.1915 355.665L43.2063 356.241L53.2917 350.983Z",
    fill: "url(#paint95_linear_1404_813)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1072 311.854L34.1989 318.219C34.1114 318.51 34.2194 318.826 34.4707 318.998C35.3895 319.628 37.7907 320.879 41.0849 319.663C41.4618 319.524 41.7199 319.172 41.7523 318.771L42.2047 313.227L36.1072 311.854Z",
    fill: "url(#paint96_linear_1404_813)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2818 306.7C47.2818 306.7 46.3434 313.297 43.8091 315.326C41.2747 317.355 36.3367 315.827 34.6689 310.853L37.9921 302.349L47.2818 306.7Z",
    fill: "url(#paint97_linear_1404_813)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6174 307.853C37.8102 307.915 38.0121 307.791 38.0422 307.591C38.1338 306.982 38.362 305.777 38.8243 304.956C38.8243 304.956 38.5823 304.09 41.012 305.398C43.4413 306.705 47.0904 308.626 49.2389 307.482C51.3335 306.367 53.4551 300.755 47.9196 301.795C47.709 301.834 47.5153 301.666 47.5311 301.453C47.599 300.53 47.5077 298.408 45.3586 297.727C43.3477 297.089 42.2467 297.997 41.7929 298.545C41.6595 298.706 41.4116 298.703 41.2844 298.537C40.6819 297.75 39.0458 296.077 36.6375 297.138C34.6538 298.012 34.3451 299.234 34.3779 299.995C34.3884 300.242 34.1382 300.409 33.9138 300.306C33.3064 300.026 32.3292 299.881 31.3929 301.054C30.0988 302.675 31.9482 304.081 32.503 304.45C32.594 304.511 32.6504 304.611 32.651 304.72C32.6563 305.563 32.7874 309.241 34.6312 311.317C34.791 311.496 35.0859 311.444 35.179 311.222L36.5986 307.84C36.6644 307.683 36.8397 307.602 37.0018 307.655L37.6174 307.853Z",
    fill: "url(#paint98_linear_1404_813)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6464 308.54C37.6464 308.54 36.7795 305.009 35.4628 306.155C34.1462 307.302 35.806 309.825 37.3146 310.305L37.6464 308.54Z",
    fill: "url(#paint99_linear_1404_813)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4775 334.43H49.4767C49.3269 334.429 49.2057 334.308 49.2063 334.158C49.2192 330.37 47.7557 325.338 47.7407 325.288C47.6986 325.144 47.7811 324.993 47.9248 324.951C48.0696 324.91 48.2194 324.991 48.2615 325.135C48.2765 325.186 49.7619 330.294 49.7488 334.159C49.7485 334.309 49.6271 334.43 49.4775 334.43Z",
    fill: "url(#paint100_linear_1404_813)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1958 336.299C41.1157 336.299 41.0361 336.264 40.9825 336.196C40.8187 335.988 36.9483 331.068 35.572 327.58C35.517 327.441 35.5852 327.283 35.7248 327.228C35.864 327.174 36.022 327.242 36.0764 327.381C37.4238 330.794 41.369 335.81 41.4085 335.86C41.5013 335.978 41.4811 336.148 41.3638 336.241C41.314 336.28 41.2546 336.299 41.1958 336.299Z",
    fill: "url(#paint101_linear_1404_813)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6349 344.071L35.4333 343.985C29.6284 341.5 26.158 334.794 26.0129 334.51C25.9447 334.376 25.9977 334.213 26.1314 334.145C26.2651 334.077 26.4281 334.13 26.4963 334.263C26.5305 334.33 29.9426 340.919 35.4468 343.398L35.9799 342.644C36.0668 342.522 36.2359 342.493 36.3579 342.579C36.4802 342.666 36.5094 342.835 36.4228 342.957L35.6349 344.071Z",
    fill: "url(#paint102_linear_1404_813)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9874 330.477C52.9874 330.477 57.1989 342.607 65.4068 333.375L66.1883 333.028L72.0717 329.006L71.4163 331.335C71.0538 332.623 70.1192 333.672 68.8822 334.181L68.1071 334.5C66.6322 337.566 63.4717 342.211 58.6051 343.092C51.301 344.415 47.5547 334.546 47.5547 334.546L52.9874 330.477Z",
    fill: "url(#paint103_linear_1404_813)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0064 325.909L75.4193 326.475C75.6197 326.749 75.5533 327.135 75.2727 327.327L66.0044 333.658C65.7589 333.826 65.428 333.789 65.225 333.572C64.983 333.314 65.0155 332.904 65.2946 332.686L74.15 325.789C74.418 325.58 74.806 325.635 75.0064 325.909Z",
    fill: "url(#paint104_linear_1404_813)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6396 331.754C66.7564 331.652 59.4777 328.09 56.7374 328.416C54.0687 328.733 50.9292 330.727 48.0019 333.091C45.3666 335.219 42.6558 336.591 40.112 336.485C40.112 336.485 35.7601 341.218 36.7245 344.073C36.7245 344.073 41.5571 345.215 45.6826 341.141C49.605 337.268 53.9364 332.332 56.374 331.432C56.5782 331.356 56.8023 331.383 56.9861 331.5C57.7184 331.967 60.0035 333.086 62.9955 331.297C62.9955 331.297 65.4298 332.812 66.6396 331.754Z",
    fill: "url(#paint105_linear_1404_813)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4813 315.283C64.2572 316.984 63.7858 320.261 63.2387 322.296C63.1076 322.783 62.6822 323.132 62.1789 323.169C60.5811 323.286 57.0151 323.43 54.9357 322.612C54.4658 322.427 54.1735 321.958 54.1966 321.453C54.2686 319.877 54.4713 316.218 54.8777 314.028C54.9901 313.422 55.5445 313.006 56.1575 313.062C57.8454 313.219 61.2424 313.559 63.5038 313.954C64.1346 314.064 64.565 314.648 64.4813 315.283Z",
    fill: "url(#paint106_linear_1404_813)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3449 317.7L69.1407 319.076C69.0945 319.386 68.8072 319.602 68.4961 319.559L66.8828 319.336C66.58 319.294 66.3638 319.022 66.391 318.717L66.4949 317.565C66.5215 317.27 66.7687 317.044 67.0651 317.044H68.7788C69.1284 317.044 69.3964 317.354 69.3449 317.7Z",
    fill: "#BDD0FB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7048 323.138L68.3721 324.973C68.2434 325.683 67.5195 326.116 66.8334 325.895L65.6136 325.502C65.0852 325.332 64.7443 324.82 64.7914 324.267L64.9436 322.475C65.0056 321.744 65.7075 321.242 66.4197 321.42L67.8203 321.769C68.4298 321.921 68.8168 322.52 68.7048 323.138Z",
    fill: "url(#paint107_linear_1404_813)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_813",
    x1: 485.425,
    y1: 315.362,
    x2: 486.947,
    y2: 326.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_813",
    x1: 485.998,
    y1: 323.832,
    x2: 489.518,
    y2: 346.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1404_813",
    x1: 492.118,
    y1: 317.474,
    x2: 487.599,
    y2: 317.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1404_813",
    x1: 472.76,
    y1: 301.586,
    x2: 483.205,
    y2: 310.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1404_813",
    x1: 476.241,
    y1: 299.385,
    x2: 464.47,
    y2: 299.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1404_813",
    x1: 473.234,
    y1: 292.332,
    x2: 466.886,
    y2: 292.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1404_813",
    x1: 459.542,
    y1: 263.446,
    x2: 505.863,
    y2: 304.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1404_813",
    x1: 486.964,
    y1: 285.513,
    x2: 478.467,
    y2: 267.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1404_813",
    x1: 453.292,
    y1: 238.732,
    x2: 445.505,
    y2: 257.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1404_813",
    x1: 456.846,
    y1: 224.95,
    x2: 461.142,
    y2: 180.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1404_813",
    x1: 461.073,
    y1: 208.176,
    x2: 466.443,
    y2: 228.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1404_813",
    x1: 871.26,
    y1: 351.301,
    x2: 854.344,
    y2: 345.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1404_813",
    x1: 465.285,
    y1: 196.206,
    x2: 452.802,
    y2: 212.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1404_813",
    x1: 871.775,
    y1: 349.817,
    x2: 854.859,
    y2: 343.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1404_813",
    x1: 409.784,
    y1: 289.339,
    x2: 461.606,
    y2: 224.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1404_813",
    x1: 459.011,
    y1: 227.652,
    x2: 459.962,
    y2: 243.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1404_813",
    x1: 785.66,
    y1: 760.57,
    x2: 769.157,
    y2: 735.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1404_813",
    x1: 119.337,
    y1: 282.431,
    x2: 130.685,
    y2: 282.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1404_813",
    x1: 147.745,
    y1: 269.044,
    x2: 106.463,
    y2: 301.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1404_813",
    x1: 124.368,
    y1: 267.33,
    x2: 121.701,
    y2: 290.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1404_813",
    x1: 178.082,
    y1: 252.231,
    x2: 141.162,
    y2: 281.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1404_813",
    x1: 161.572,
    y1: 256.13,
    x2: 176.188,
    y2: 256.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1404_813",
    x1: 166.994,
    y1: 247.107,
    x2: 160.561,
    y2: 262.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1404_813",
    x1: 120.866,
    y1: 245.658,
    x2: 175.599,
    y2: 245.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1404_813",
    x1: 180.614,
    y1: 168.436,
    x2: 100.597,
    y2: 233.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1404_813",
    x1: 189.02,
    y1: 178.766,
    x2: 109.002,
    y2: 243.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1404_813",
    x1: 143.93,
    y1: 204.902,
    x2: 121.959,
    y2: 227.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1404_813",
    x1: 172.534,
    y1: 161.697,
    x2: 97.474,
    y2: 222.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1404_813",
    x1: 162.407,
    y1: 161.472,
    x2: 157.216,
    y2: 179.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1404_813",
    x1: 169.386,
    y1: 159.196,
    x2: 159.899,
    y2: 165.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1404_813",
    x1: 158.861,
    y1: 165.209,
    x2: 172.777,
    y2: 157.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1404_813",
    x1: 155.24,
    y1: 178.077,
    x2: 159.461,
    y2: 163.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1404_813",
    x1: 171.074,
    y1: 158.506,
    x2: 216.101,
    y2: 158.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1404_813",
    x1: 227.048,
    y1: 146.504,
    x2: 192.871,
    y2: 182.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1404_813",
    x1: 173.083,
    y1: 157.128,
    x2: 162.233,
    y2: 173.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1404_813",
    x1: 193.316,
    y1: 164.517,
    x2: 199.788,
    y2: 164.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1404_813",
    x1: 365.353,
    y1: 126.59,
    x2: 356.744,
    y2: 126.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1404_813",
    x1: 343.659,
    y1: 116.109,
    x2: 375.322,
    y2: 140.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1404_813",
    x1: 362.528,
    y1: 116.489,
    x2: 360.81,
    y2: 131.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1404_813",
    x1: 391.707,
    y1: 123.487,
    x2: 361.088,
    y2: 147.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1404_813",
    x1: 378.013,
    y1: 126.713,
    x2: 390.128,
    y2: 126.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1404_813",
    x1: 380.633,
    y1: 118.408,
    x2: 379.025,
    y2: 132.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1404_813",
    x1: 370.708,
    y1: 117.959,
    x2: 372.637,
    y2: 57.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1404_813",
    x1: 363.207,
    y1: 63.0527,
    x2: 347.365,
    y2: 154.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1404_813",
    x1: 367.361,
    y1: 22.4156,
    x2: 368.436,
    y2: 39.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1404_813",
    x1: 378.439,
    y1: 9.66619,
    x2: 363.671,
    y2: 17.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1404_813",
    x1: 362.069,
    y1: 12.8022,
    x2: 374.247,
    y2: 6.08828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1404_813",
    x1: 377.906,
    y1: 8.68922,
    x2: 363.138,
    y2: 16.7445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1404_813",
    x1: 344.44,
    y1: 59.7959,
    x2: 328.598,
    y2: 151.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1404_813",
    x1: 347.396,
    y1: -1.48934,
    x2: 343.044,
    y2: 12.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1404_813",
    x1: 402.819,
    y1: 125.57,
    x2: 418.661,
    y2: 216.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1404_813",
    x1: 388.665,
    y1: -0.245812,
    x2: 393.017,
    y2: 14.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1404_813",
    x1: 255.919,
    y1: 355.418,
    x2: 249.464,
    y2: 314.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1404_813",
    x1: 253.381,
    y1: 355.736,
    x2: 246.782,
    y2: 314.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1404_813",
    x1: 258.614,
    y1: 356.947,
    x2: 251.755,
    y2: 313.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1404_813",
    x1: 271.498,
    y1: 357.192,
    x2: 265.949,
    y2: 373.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1404_813",
    x1: 267.465,
    y1: 349.111,
    x2: 272.716,
    y2: 349.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1404_813",
    x1: 260.197,
    y1: 335.216,
    x2: 282.513,
    y2: 303.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1404_813",
    x1: 261.176,
    y1: 388.564,
    x2: 267.084,
    y2: 372.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1404_813",
    x1: 265.283,
    y1: 360.643,
    x2: 279.404,
    y2: 360.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1404_813",
    x1: 263.666,
    y1: 353.958,
    x2: 268.595,
    y2: 353.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1404_813",
    x1: 252.153,
    y1: 350.802,
    x2: 253.383,
    y2: 308.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1404_813",
    x1: 282.642,
    y1: 310.13,
    x2: 270.518,
    y2: 291.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1404_813",
    x1: 278.726,
    y1: 297.123,
    x2: 295.918,
    y2: 297.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1404_813",
    x1: 270.796,
    y1: 276.534,
    x2: 232.139,
    y2: 304.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1404_813",
    x1: 271.004,
    y1: 267.236,
    x2: 262.59,
    y2: 279.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1404_813",
    x1: 265.253,
    y1: 268.911,
    x2: 226.595,
    y2: 297.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1404_813",
    x1: 237.527,
    y1: 286.403,
    x2: 271.265,
    y2: 284.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1404_813",
    x1: 254.543,
    y1: 297.33,
    x2: 210.871,
    y2: 373.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1404_813",
    x1: 281.438,
    y1: 263.49,
    x2: 265.149,
    y2: 266.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1404_813",
    x1: 264.085,
    y1: 260.567,
    x2: 280.579,
    y2: 256.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1404_813",
    x1: 281.191,
    y1: 262.089,
    x2: 264.902,
    y2: 264.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1404_813",
    x1: 260.287,
    y1: 296.425,
    x2: 282.319,
    y2: 303.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1404_813",
    x1: 290.552,
    y1: 281.98,
    x2: 306.419,
    y2: 298.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1404_813",
    x1: 273.004,
    y1: 207.504,
    x2: 268.726,
    y2: 180.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1404_813",
    x1: 271.322,
    y1: 207.715,
    x2: 266.948,
    y2: 180.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1404_813",
    x1: 274.594,
    y1: 207.251,
    x2: 270.315,
    y2: 180.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1404_813",
    x1: 288.058,
    y1: 189.148,
    x2: 305.063,
    y2: 168.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1404_813",
    x1: 284.449,
    y1: 199.54,
    x2: 286.519,
    y2: 231.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1404_813",
    x1: 277.847,
    y1: 167.327,
    x2: 298.074,
    y2: 198.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1404_813",
    x1: 280.918,
    y1: 199.988,
    x2: 275.583,
    y2: 180.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1404_813",
    x1: 304.424,
    y1: 198.237,
    x2: 306.495,
    y2: 229.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1404_813",
    x1: 276.608,
    y1: 148.288,
    x2: 260.827,
    y2: 182.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1404_813",
    x1: 278.903,
    y1: 137.387,
    x2: 275.86,
    y2: 147.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1404_813",
    x1: 719.613,
    y1: -126.76,
    x2: 707.262,
    y2: -119.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1404_813",
    x1: 259.748,
    y1: 115.862,
    x2: 281.757,
    y2: 138.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1404_813",
    x1: 719.049,
    y1: -127.707,
    x2: 706.698,
    y2: -120.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1404_813",
    x1: 278.694,
    y1: 162.334,
    x2: 258.288,
    y2: 173.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1404_813",
    x1: 249.966,
    y1: 125.264,
    x2: 271.975,
    y2: 148.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1404_813",
    x1: 267.169,
    y1: 164.201,
    x2: 284.473,
    y2: 169.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1404_813",
    x1: 290.939,
    y1: 152.856,
    x2: 303.4,
    y2: 166.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1404_813",
    x1: 82.8523,
    y1: 358.599,
    x2: 92.2594,
    y2: 368.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1404_813",
    x1: 68.2853,
    y1: 349.032,
    x2: 77.8838,
    y2: 312.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1404_813",
    x1: 95.3317,
    y1: 383.26,
    x2: 113.126,
    y2: 396.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1404_813",
    x1: 95.5873,
    y1: 358.49,
    x2: 58.3671,
    y2: 372.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1404_813",
    x1: 30.9418,
    y1: 278.651,
    x2: 39.1761,
    y2: 331.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1404_813",
    x1: 38.2807,
    y1: 315.7,
    x2: 39.1701,
    y2: 307.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1404_813",
    x1: 33.0832,
    y1: 304.23,
    x2: 45.2557,
    y2: 312.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1404_813",
    x1: 38.9323,
    y1: 289.966,
    x2: 42.5771,
    y2: 310.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1404_813",
    x1: 32.4409,
    y1: 305.139,
    x2: 44.6132,
    y2: 313.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1404_813",
    x1: 47.7297,
    y1: 329.685,
    x2: 49.7489,
    y2: 329.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1404_813",
    x1: 35.5528,
    y1: 331.754,
    x2: 41.4668,
    y2: 331.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1404_813",
    x1: 25.9834,
    y1: 339.093,
    x2: 36.4726,
    y2: 339.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1404_813",
    x1: 61.1782,
    y1: 339.609,
    x2: 65.2954,
    y2: 363.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1404_813",
    x1: 75.5349,
    y1: 329.713,
    x2: 65.0623,
    y2: 329.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1404_813",
    x1: 18.5296,
    y1: 354.516,
    x2: 46.9917,
    y2: 337.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1404_813",
    x1: 56.3368,
    y1: 313.637,
    x2: 68.8749,
    y2: 333.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1404_813",
    x1: 63.5631,
    y1: 319.221,
    x2: 68.8676,
    y2: 326.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image3.d0777e11969512760b66dfa2206d7092.svg";
export { ForwardRef as ReactComponent };